import React from 'react';
import PropTypes from 'prop-types';

import styles from './referralCodeSection.scss';

const ReferralCodeSection = ({
    value,
    onChange,
    appliedCode,
    error,
    isApplying,
    onApply,
    onClear,
    disabled,
    'data-testid': dataTestId,
}) => {
    const trimmed = value.trim();
    const isApplied = Boolean(appliedCode) && trimmed === appliedCode.trim();
    const canApply = !disabled && !isApplying && trimmed !== '' && !isApplied;

    const handleApply = () => {
        if (canApply) {
            onApply();
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleApply();
        }
    };

    return (
        <div className={styles.section} data-testid={dataTestId}>
            <label
                className={styles.label}
                htmlFor="referral-code-input"
                data-testid={dataTestId && `${dataTestId}.label`}
            >
                Referral Code <span className={styles.labelOptional} data-testid={dataTestId && `${dataTestId}.label-optional`}>(Optional)</span>
            </label>
            <div className={styles.inputRow}>
                <div className={styles.inputWrapper}>
                    <input
                        id="referral-code-input"
                        type="text"
                        className={styles.input}
                        placeholder="Eg JACOBS-4821"
                        value={value}
                        onChange={e => onChange(e.target.value)}
                        onKeyDown={handleKeyDown}
                        disabled={disabled || isApplying || isApplied}
                        data-testid={dataTestId && `${dataTestId}.input`}
                    />
                    {value !== '' && !isApplying && (
                        <button
                            type="button"
                            className={styles.clearBtn}
                            onClick={onClear}
                            aria-label="Clear referral code"
                            data-testid={dataTestId && `${dataTestId}.clear-btn`}
                        >
                            <i className="fas fa-times-circle" aria-hidden />
                        </button>
                    )}
                </div>
                <button
                    type="button"
                    className={styles.applyBtn}
                    onClick={handleApply}
                    disabled={!canApply}
                    data-testid={dataTestId && `${dataTestId}.apply-btn`}
                >
                    {isApplying && <i className="fas fa-circle-notch fa-spin" />}
                    {isApplied ? 'Applied' : 'Apply'}
                </button>
            </div>
            {error && (
                <div
                    className={styles.error}
                    data-testid={dataTestId && `${dataTestId}.error`}
                >
                    {error}
                </div>
            )}
        </div>
    );
};

ReferralCodeSection.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    appliedCode: PropTypes.string,
    error: PropTypes.string,
    isApplying: PropTypes.bool,
    onApply: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    'data-testid': PropTypes.string,
};

ReferralCodeSection.defaultProps = {
    value: '',
    appliedCode: null,
    error: '',
    isApplying: false,
    disabled: false,
    'data-testid': null,
};

export default ReferralCodeSection;
